<template>
  <div style="background: #F6F7FB;width: 100%;height: 100%;padding: 2% 0">
    <div class="introduce">
      <div style="display: flex;flex-direction: row;margin-left: 15%;margin-right: 15%">
        <div class="out">
          <div class="title1">轻松登录</div>
          <div class="title1">即刻发布职位</div>
          <div style="color: #6C6C6C;font-size: 16px;margin-top: 43px">餐饮、零售、物流、主播等全行业覆盖</div>
          <img src="@/assets/img/login_icon.png"
               style="width: 240px;height: 240px;margin-top: 77px;margin-bottom: 40px"/>
        </div>
        <div class="out" style="margin-left: 40px;flex: 1">
          <div class="title1" style="font-size: 26px">欢迎使用商家管理后台</div>
          <div class="title1" style="font-size: 20px;font-weight: normal;margin-top: 20px">微信安全登录</div>
          <div style="color: #6C6C6C;font-size: 16px;margin-top: 16px">未注册的微信号登录时将自动创建商家版账号</div>
          <div id="qrcodeContainer" style="margin-top: 40px;width: 146px;height: 146px">
            <img :src="imageBase64" style="max-width: 100%;height: auto;">
          </div>
          <div style="display: flex;flex-direction: row;margin-top: 40px">
            <div class="protocal">扫码表示同意</div>
            <a :href="util.getUserProtocal()" class="protocal" target="_blank">《用户协议》</a>
            <div class="protocal">与</div>
            <a :href="util.getPrivacyProtocal()" class="protocal" target="_blank">《隐私协议》</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  name: 'LoginToC',
  created() {
    this.getLoginWxMiniInfo()
  },
  data() {
    return {
      uuid: null,
      timer: null,
      imageBase64: null
    }
  },
  beforeDestroy() {
    this.stopPolling()
  },
  methods: {
    login() {
      this.$router.replace('/hometoc')
    },
    getLoginWxMiniInfo() {
      api.statistics
        .pcMpQrCode({
          'page': 'pages/userlogin/loginPage',
          'env_version': 'release'//要打开的小程序版本。正式版为 "release"，体验版为 "trial"，开发版为 "develop"。默认是正式版。
        })
        .then(res => {
          this.uuid = res.data.uuid
          this.imageBase64 = res.data.qrcodeBase64
          this.getUserInfo()
        })
        .catch(error => {
        })
    },
    getUserInfo() {
      api.statistics
        .pcMpQrCodeLogin({
          'uuid': this.uuid
        })
        .then(res => {
          if (res.code == 2000) {
            this.stopPolling()
            this.$store
              .dispatch('login', res)
              .catch(err => {
                this.$Message.error('请求出错，请刷新页面')
              })
          } else {
            this.next()
          }
        })
        .catch(error => {
          this.next()
        })
    },
    stopPolling() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    next() {
      // 等上次请求结束后再延迟执行下一次
      this.timer = setTimeout(() => {
        this.getUserInfo()
      }, 1000)
    }
  }
};
</script>

<style scoped>
.introduce {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.title1 {
  font-size: 20px;
  font-weight: bold;
  color: black;
}

.out {
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 20px;
  padding: 30px 20px;
  align-items: center;
}

.protocal {
  color: #6C6C6C;
  font-size: 16px;
  text-decoration: none;
}

</style>
